import React, { useState } from "react";
import "./presentation.css";
import { Outlet } from "react-router-dom";
import { PowerContext } from "src/contexts/context";
import PowerSocket from "src/components/Stomp/Powers_Stomp";

const App = () => {
  const [powers, setPowers] = useState({ data: [], counter: 0 });

  return (
    <PowerContext.Provider value={{ powers, setPowers }}>
      <PowerSocket />
      <Outlet></Outlet>
    </PowerContext.Provider>
  );
};

export default App;
